import { useAuth } from '../hooks/useAuth';
import { Card, Button, Badge, PageHeader } from '../components/ui';

export function Profile() {
    const { user, logout } = useAuth();

    if (!user) return null;

    const roleLabels: Record<string, string> = {
        ADMIN: 'ผู้ดูแลระบบ',
        EXECUTIVE: 'ผู้บริหาร',
        MANAGER: 'ผู้จัดการ',
        EMPLOYEE: 'พนักงาน',
    };

    return (
        <div className="max-w-md mx-auto">
            <PageHeader title="โปรไฟล์" />

            <Card padding="lg">
                {/* Avatar */}
                <div className="text-center mb-6">
                    {user.picture ? (
                        <img
                            src={user.picture}
                            alt={user.name}
                            className="w-24 h-24 rounded-full mx-auto ring-4 ring-neutral-100 object-cover"
                        />
                    ) : (
                        <div className="w-24 h-24 bg-primary rounded-full mx-auto flex items-center justify-center">
                            <span className="text-white text-3xl font-bold">{user.name.charAt(0)}</span>
                        </div>
                    )}
                    <h2 className="text-xl font-bold text-neutral-900 mt-4">{user.name}</h2>
                    <div className="flex items-center justify-center gap-2 mt-3">
                        <Badge variant="primary">{roleLabels[user.effectiveRole]}</Badge>
                        <Badge variant={user.status === 'active' ? 'success' : 'warning'}>
                            {user.status === 'active' ? 'Active' : 'Pending'}
                        </Badge>
                    </div>
                </div>

                {/* Info */}
                <div className="space-y-0 divide-y divide-neutral-100">
                    <InfoRow label="User ID" value={user.userId.substring(0, 24) + '...'} mono />
                    <InfoRow label="ทีม" value={`ทีม ${user.team}`} />
                    <InfoRow label="บทบาท" value={roleLabels[user.effectiveRole]} />
                    <InfoRow
                        label="สถานะ"
                        value={user.status === 'active' ? 'ใช้งานได้' : 'รอการอนุมัติ'}
                        highlight={user.status === 'active'}
                    />
                </div>

                {/* Logout */}
                <div className="mt-8">
                    <Button onClick={logout} variant="secondary" className="w-full">
                        ออกจากระบบ
                    </Button>
                </div>
            </Card>

            {/* Footer */}
            <div className="mt-8 text-center text-xs text-neutral-400">
                <p>NS Small B2B v1.0</p>
                <p>© 2026 DoHome Public Company Limited</p>
            </div>
        </div>
    );
}

function InfoRow({
    label,
    value,
    mono = false,
    highlight = false
}: {
    label: string;
    value: string;
    mono?: boolean;
    highlight?: boolean;
}) {
    return (
        <div className="flex justify-between py-4">
            <span className="text-neutral-500">{label}</span>
            <span className={`
        font-medium 
        ${mono ? 'font-mono text-xs' : ''} 
        ${highlight ? 'text-success' : 'text-neutral-900'}
      `}>
                {value}
            </span>
        </div>
    );
}
